import React, { useState } from "react";
import "./Register.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { registerUser } from "../../Redux/Slices/Utility/RegisterSlice";
import { useForm } from "react-hook-form";
import { AlertPopup } from "../../Asset/common";
import { IoMdEyeOff } from "react-icons/io";
import { IoEye } from "react-icons/io5";
import Loader from "../Utility/Loader";

const STATE_OPTIONS = [
  "Andhra Pradesh",
  "Gujarat",
  "Karnataka",
  "Maharashtra",
  "Rajasthan",
  "Tamil Nadu",
  "Uttar Pradesh",
  "West Bengal",
];

const COUNTRY_OPTIONS = [
  "India",
  "United States",
  "United Kingdom",
  "United Arab Emirates",
  "Singapore",
];

const ACCOUNT_TYPE_OPTIONS = ["Personal", "Business", "Corporate"];

function Register() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    if (
      Object.entries(data).every(([key, val]) => {
        if (key === "AgreeTerms") {
          return val === true;
        }
        return typeof val === "string" && val.trim() !== "";
      })
    ) {
      if (data.Password !== data.Password) {
        AlertPopup.warningPopup("Password does not match with confirm password !!");
        return;
      }

      try {
        debugger
        // await dispatch(registerUser(data));
        // navigate("/login");

        const success = await dispatch(registerUser(data));
        if (success) {
          navigate("/login"); // ✅ only on real 200 success
        }
        // error case ma kai j navigate nahi thay, form data as-it-is j rahese
      } catch (error) {
        console.error("Error registering user:", error);
        AlertPopup.warningPopup("An error occurred while registering. Please try again later.");
      }
    } else {
      AlertPopup.warningPopup("Please fill in all the required fields !!");
    }
  };

  return (
    <>
      <Loader />
      <div className="register_page">
        <div className="register_overlay" />
        <div className="register_wrapper">
          <div className="register_form_card">
            <div className="register_top_header">
              <h1>New Account Request</h1>
              <p>
                Fill in the form below to request for an account from Sun Diam. We
                will look into the request as soon as possible.
              </p>
            </div>

            <form onSubmit={handleSubmit(onSubmit)} className="register_form">
              <div className="register_row">
                <div className="register_field">
                  <label>First Name</label>
                  <input
                    type="text"
                    placeholder="Enter first name"
                    className="register_input"
                    {...register("FirstName", {
                      required: "This field is required",
                    })}
                  />
                  {errors.FirstName && (
                    <span className="validation">{errors.FirstName.message}</span>
                  )}
                </div>
                <div className="register_field">
                  <label>Last Name</label>
                  <input
                    type="text"
                    placeholder="Enter last name"
                    className="register_input"
                    {...register("LastName", {
                      required: "This field is required",
                    })}
                  />
                  {errors.LastName && (
                    <span className="validation">{errors.LastName.message}</span>
                  )}
                </div>
              </div>

              <div className="register_row">
                <div className="register_field">
                  <label>Username</label>
                  <input
                    type="text"
                    placeholder="Enter username"
                    className="register_input"
                    {...register("Username", {
                      required: "This field is required",
                    })}
                  />
                  {errors.Username && (
                    <span className="validation">{errors.Username.message}</span>
                  )}
                </div>
                <div className="register_field">
                  <label>Mobile No.</label>
                  <input
                    type="text"
                    placeholder="Enter number"
                    className="register_input"
                    {...register("PhoneNumber", {
                      required: "This field is required",
                    })}
                  />
                  {errors.PhoneNumber && (
                    <span className="validation">{errors.PhoneNumber.message}</span>
                  )}
                </div>
              </div>

              <div className="register_row">
                <div className="register_field">
                  <label>Email</label>
                  <input
                    type="text"
                    placeholder="Enter email"
                    className="register_input"
                    {...register("Email", {
                      required: "This field is required",
                      pattern: {
                        value: /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/,
                        message: "Invalid email address",
                      },
                    })}
                  />
                  {errors.Email && (
                    <span className="validation">{errors.Email.message}</span>
                  )}
                </div>
                <div className="register_field">
                  <label>Password</label>
                  <div className="password_wrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter Password"
                      className="register_input"
                      autoComplete="new-password"
                      {...register("Password", {
                        required: "This field is required",
                        pattern: {
                          value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                          message:
                            "Password must contain at least one digit, one lowercase letter, one uppercase letter, and be at least 8 characters long",
                        },
                      })}
                    />
                    <button
                      type="button"
                      className="password_toggle_button"
                      onClick={() => setShowPassword((prev) => !prev)}
                    >
                      {showPassword ? <IoMdEyeOff /> : <IoEye />}
                    </button>
                  </div>
                  {errors.Password && (
                    <span className="validation">{errors.Password.message}</span>
                  )}
                </div>
              </div>

              <div className="register_full_width">
                <div className="register_field">
                  <label>Address</label>
                  <input
                    type="text"
                    placeholder="Enter address"
                    className="register_input"
                    {...register("AddressLine1", {
                      required: "This field is required",
                    })}
                  />
                  {errors.AddressLine1 && (
                    <span className="validation">{errors.AddressLine1.message}</span>
                  )}
                </div>
              </div>

              <div className="register_row">
                <div className="register_field">
                  <label>City</label>
                  <input
                    type="text"
                    placeholder="Enter city name"
                    className="register_input"
                    {...register("City", {
                      required: "This field is required",
                    })}
                  />
                  {errors.City && (
                    <span className="validation">{errors.City.message}</span>
                  )}
                </div>
                <div className="register_field">
                  <label>State/Province</label>
                  <select
                    className="register_input"
                    {...register("State", {
                      required: "This field is required",
                    })}
                  >
                    <option value="" disabled>
                      Select state
                    </option>
                    {STATE_OPTIONS.map((state) => (
                      <option key={state} value={state}>
                        {state}
                      </option>
                    ))}
                  </select>
                  {errors.State && (
                    <span className="validation">{errors.State.message}</span>
                  )}
                </div>
              </div>

              <div className="register_row">
                <div className="register_field">
                  <label>Country</label>
                  <select
                    className="register_input"
                    {...register("Country", {
                      required: "This field is required",
                    })}
                  >
                    <option value="" disabled>
                      Select country
                    </option>
                    {COUNTRY_OPTIONS.map((country) => (
                      <option key={country} value={country}>
                        {country}
                      </option>
                    ))}
                  </select>
                  {errors.Country && (
                    <span className="validation">{errors.Country.message}</span>
                  )}
                </div>
                <div className="register_field">
                  <label>Pin code/Postal code</label>
                  <input
                    type="text"
                    placeholder="Enter pin code/postal code"
                    className="register_input"
                    {...register("PinCode", {
                      required: "This field is required",
                    })}
                  />
                  {errors.PinCode && (
                    <span className="validation">{errors.PinCode.message}</span>
                  )}
                </div>
              </div>

              <div className="register_row">
                <div className="register_field">
                  <label>Select Account Type</label>
                  <select
                    className="register_input"
                    {...register("AccountType", {
                      required: "This field is required",
                    })}
                  >
                    <option value="" disabled>
                      Select type
                    </option>
                    {ACCOUNT_TYPE_OPTIONS.map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                  {errors.AccountType && (
                    <span className="validation">{errors.AccountType.message}</span>
                  )}
                </div>
                <div className="register_field">
                  <label>How do you know us?</label>
                  <input
                    type="text"
                    placeholder="Select reference"
                    className="register_input"
                    {...register("Reference", {
                      required: "This field is required",
                    })}
                  />
                  {errors.Reference && (
                    <span className="validation">{errors.Reference.message}</span>
                  )}
                </div>
              </div>

              <div className="register_terms">
                <label className="register_checkbox_label">
                  <input
                    type="checkbox"
                    {...register("AgreeTerms", {
                      required: "Please accept Terms & conditions",
                    })}
                  />
                  <span>I have read and agree to the Terms & conditions*</span>
                </label>
                {errors.AgreeTerms && (
                  <span className="validation">{errors.AgreeTerms.message}</span>
                )}
              </div>

              <button type="submit" className="register_button">
                Continue
              </button>

              <div className="register_footer">
                <Link to="/login" className="back_link">
                  ← Back to Sign in
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>

  );
}

export default Register;